import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import analysts_Architect_INTJ_personality_header from '../../images/personality_types_details/analysts_Architect_INTJ_personality_header.svg'
import analysts_Architect_INTJ_friendships from '../../images/personality_types_details/analysts_Architect_INTJ_friendships.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'
import circleback from '../../images/personality_types_details/circleback.png'

const intj_friends = () => {
    return (
        <Layout>
            <main className="q-td analyst architect">
                {/* --------------------mobile child nav bar------------------------ */}
                <nav className="top-tabs mobile-only" aria-label="Personality description">

                    <Link to='/personality-types/architect-intj-personality' className="tab with-progress">
                        <span className="title">Introduction</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-strengths-and-weaknesses" className="tab with-progress">
                        <span className="title">Strengths and Weaknesses</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-relationships-dating" className="tab with-progress ">
                        <span className="title">Romantic Relationships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab with-progress active">
                        <span className="title">Friendships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-parents" className="tab with-progress ">
                        <span className="title">Parenthood</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-careers" className="tab with-progress ">
                        <span className="title">Career Paths</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intjs-at-work" className="tab with-progress ">
                        <span className="title">Workplace Habits</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-conclusion" className="tab with-progress ">
                        <span className="title">Conclusion</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab premium">
                        <span className="title">Premium Profile</span>
                    </Link>

                </nav>
                {/* -------------------- picture and title-------------------------- */}
                <header className="type-header analyst architect">
                    <svg className="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
                        <path className="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
                        <path className="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
                    </svg>
                    <img src={analysts_Architect_INTJ_personality_header} className="scene" alt='loading...' />
                    <div className="type-info">
                        <h1><span>Architect</span> Personality</h1>
                        <div className="code">INTJ-A / INTJ-T</div>
                        <a href="#" className="difference">(What’s the difference?)</a>
                    </div>
                </header>


                {/* -------------------------side bar section------------------------------------- */}
                <div className="with-sidebars">

                    <div className="sidebar left">
                        <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
                            <div className="title">Explore This Type</div>
                            <ul>
                                <li className=""><Link to='/personality-types/architect-intj-personality'>Introduction</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-relationships-dating">Romantic Relationships</Link></li>
                                <li className="active"><Link to="/personality-types/architect-intj-friends">Friendships</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-parents">Parenthood</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-careers">Career Paths</Link></li>
                                <li className=""><Link to="/personality-types/architect-intjs-at-work">Workplace Habits</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-conclusion">Conclusion</Link></li>
                                <li className="premium"><Link to="/">Premium Profile</Link></li>
                            </ul>
                        </nav>
                        <daily-insight v-cloak personality-type="INTJ"></daily-insight>
                    </div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}
                    <article class="main description">

                        <h1>    Friendships
</h1>


                        <blockquote><p>“A friend to all is a friend to none.”</p> <footer>Aristotle</footer></blockquote>

                        <p>Sharp-witted and darkly funny, Architects (INTJs) aren’t everyone’s cup of tea – and they’re okay with that. For the most part, people with this personality type aren’t obsessed with being popular. They don’t spend their time and energy on just anyone, and they can be difficult to get to know.</p>

                        <p>But this doesn’t mean that Architects are antisocial or friendless. In fact, few things are more exhilarating to Architect personalities than the spark they feel when they connect with someone who really gets them.</p>

                        <div class="scene"><img alt="Architect (INTJ) friends" src={analysts_Architect_INTJ_friendships} /></div>

                        <h2>The Search for an Equal</h2>

                        <p>Architects tend to have strong opinions about what works, what doesn’t, what they’re looking for, and what they’re not. This mindset gives them a clear picture of what they expect from their social lives and their friends – and it can also lead them to reject anyone who doesn’t seem to meet these expectations. From the outside, people with this personality type may seem dismissive, but they would say they’re just being decisive.</p>

                        <p>In friendship, Architects are looking for an intellectual equal as much as anything else. These personalities crave mental stimulation, and they can become bored by anyone who can’t keep up with the workings of their minds. Architects need to share their expansive ideas – making small talk is something they typically avoid.</p>

                        <div class="description-pullout">
                            Architects care about depth and quality. They’d rather have just a few good friends than a large circle of acquaintances.
</div>

                        <p>In their friendships, as in other aspects of their lives, Architects prize independence. Social obligations can feel stifling to people with this personality type. Architects don’t want to feel beholden to their friends, and they don’t want their friends to feel beholden to them. For them, an ideal friendship is low drama, based on mutual respect rather than obligation.</p>

                        <p>Of course, any friendship will have its dramatic moments. When sensitive or emotional situations arise, Architects may feel out of their depth. Even with their closest friends, these personalities may struggle to offer comfort – or receive it. Architects are used to feeling knowledgeable and capable, and this sudden cluelessness can be disorienting for them.</p>

                        <h2>A Unique Friendship</h2>

                        <p>It’s not always easy to befriend an Architect. People with this personality type have little patience for social rules. Instead, they look for friends who value intellect, honesty, and self-improvement. They may become bored or irritated by anyone who falls short of this mark. Fortunately, anyone who does share these qualities is likely to appreciate Architects as well.</p>

                        <p>Among friends whom they know and respect, Architects have no trouble relaxing and being themselves. Their sarcasm and witty banter may not be for everyone – especially people who struggle to read between the lines. But Architects reward their true friends with candor and insight, along with an endless supply of fascinating stories, ideas, and conversations.</p>

                        <div class="number">04</div>


                    </article>
                </div>

                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                        <Link to='/personality-types/architect-intj-relationships-dating' className='next-feature'>
                            Romantic Relationships
                       <br /><br />
                            <img src={circleback} width={75} height={75} />
                        </Link>
                    </div>
                    <div className="part right">
                        <Link to='/personality-types/architect-intj-parents' className='next-feature'>
                            Parenthood
                       <br /><br />
                            <img src={circleforward} width={75} height={75} />
                        </Link>
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default intj_friends
